import React from "react";

function UserProfileCard() {
  return (
    <>
      <div
        className="sm:group-hover:block hidden absolute z-50 top-full transition ease-out duration-100"
        style={{ left: "-20px" }}
      >
        <div className="bg-[#fff] rounded-lg drop-shadow-xl w-80 max-w-full overflow-hidden duration-500 p-6 m-5 grid gap-5 transition m-auto">
          <div className="flex justify-between">
            <div className="bg-[#fff]/[.2] p-1">
              <img
                src="assets/images/user/user-img.jpg"
                alt="User Image"
                className="w-12"
              />
            </div>
            <div>
              <button className="border-2 py-3 px-8 rounded-full transition duration-150 ease-out text-[#000] hover:bg-[#000] hover:text-[#fff]">
                Follow
              </button>
            </div>
          </div>
          <a href="#" className="text-4xl font-semibold text-[#000]">
            STILLZ
          </a>
          <div class="text-xl font-extrabold ...">
            <span class="bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
              @stillz
            </span>
          </div>
          <div className="font-normal normal-case grid gap-4">
            <p>
              Hidden in plain sight, Colombian Artist, Director and
              Photographer, STILLZ begins the journey into the digital art world
              with reality bending collection, MOCHI.
            </p>
            <p className="truncate">Based in Los Angel</p>
          </div>
          <div className="flex items-center gap-3">
            <p className="caipalize font-normal">Followed by</p>
            <div class="flex -space-x-2 overflow-hidden">
              <a
                href="#"
                className="inline-block h-8 w-8 rounded-full ring-2 ring-white overflow-hidden"
              >
                <img src="assets/images/user/user.gif" alt="" />
              </a>
              <a
                href="#"
                className="inline-block h-8 w-8 rounded-full ring-2 ring-white overflow-hidden"
              >
                <img src="assets/images/user/user-3.jpg" alt="" />
              </a>
              <a
                href="#"
                className="inline-block h-8 w-8 rounded-full ring-2 ring-white overflow-hidden"
              >
                <img src="assets/images/user/user-6.gif" alt="" />
              </a>
              <a
                href="#"
                className="inline-block h-8 w-8 rounded-full ring-2 ring-white overflow-hidden"
              >
                <img src="assets/images/user/user.jpg" alt="" />
              </a>
              <a
                href="#"
                className="inline-block h-8 w-8 rounded-full ring-2 ring-white overflow-hidden"
              >
                <img src="assets/images/user/user-4.jpeg" alt="" />
              </a>
            </div>
          </div>
          <div className="font-semibold capitalize flex gap-4 border-t-2 pt-4">
            <a href="#" className="text-[#666666] hover:text-[#000]">
              <p className="text-[#000] text-3xl">22</p>
              <p className="text-xl font-normal">following</p>
            </a>
            <a href="#" className="text-[#666666] hover:text-[#000]">
              <p className="text-[#000] text-3xl">522</p>
              <p className="text-xl font-normal">followers</p>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserProfileCard;
